import { loadMessages } from '@progress/kendo-vue-intl';

// In order to give the pager info commas, we need to use the LocalizationProvider and IntlProvider for Kendo
loadMessages(
  {
    grid: {
      pagerInfo: '{0:#,###} - {1:#,###} of {2:#,###} items'
    }
  },
  'en-EN'
);

export default {
  cellTemplateNames: {
    logoPath: 'logoPath',
    sample: 'sample',
    buttons: 'buttons',
    unit: 'unit',
    customerName: 'customerName',
    severity: 'severity',
    header: 'header'
  },
  classes: {
    ascendArrow: 'k-i-sort-asc-sm',
    descendArrow: 'k-i-sort-desc-sm',
    grid: 'k-grid',
    icon: 'k-icon'
  },
  filter: {
    boolean: 'boolean',
    date: 'date',
    field: 'field',
    numeric: 'numeric',
    operator: 'operator',
    operators: {
      contains: 'contains',
      doesnotcontain: 'doesnotcontain',
      doesnotendwith: 'doesnotendwith',
      doesnotstartwith: 'doesnotstartwith',
      endswith: 'endswith',
      eq: 'eq',
      isempty: 'isempty',
      isnotempty: 'isnotempty',
      isnotnull: 'isnotnull',
      isnull: 'isnull',
      neq: 'neq',
      startswith: 'startswith'
    },
    text: 'text',
    value: 'query'
  },
  sort: {
    asc: 'asc',
    desc: 'desc',
    dir: 'dir',
    orderBy: 'orderBy'
  },
  pagination: {
    numeric: 'numeric'
  },
  size: {
    minResizableWidth: '100px',
    width: {
      boolean: '100px',
      comment: '900px',
      buttons: '150px',
      button: '50px',
      int: '100px',
      long: '125px',
      date: '150px',
      decimal: '75px',
      default: '200px',
      small: '100px'
    }
  },
  spinner: {
    timeout: 350
  }
};
